import React from "react";
import "./style.scss";
import OliverText from "@builder/components/general/OliverText";
import { useTranslation } from "react-i18next";
import DynamicIcon from "@common/components/DynamicIcon";

interface SelectImageProps {
    type: "image" | "icon";
    callback: () => void;
    removeCallback?: () => void;
    img?: string;
    label?: string;
}

const SelectImage = ({ type, callback, removeCallback, img, label }: SelectImageProps) => {
    const { t } = useTranslation();

    let Image = null;
    if (img) {
        if (type === "image") {
            Image = () => <img src={img} />;
        } else {
            Image = () => <DynamicIcon name={img} />;
        }
    }

    const handleRemove = (e: React.MouseEvent) => {
        e.stopPropagation();
        removeCallback && removeCallback();
    };

    return (
        <>
            <OliverText text={label ? t("generalComponents.selectImage." + label) : t("generalComponents.selectImage.Select Image")} size="xs" />
            <button onClick={callback} className="select-image-wrapper">
                {Image ? (
                    <>
                        {removeCallback && (
                            <div className="remove-image" onClick={handleRemove}>
                                <img src="./x-icon-dark.svg" alt="" />
                            </div>
                        )}
                        <Image />
                    </>
                ) : (
                    <div className="fake-button">{t("generalComponents.selectImage.Select " + type)}</div>
                )}
            </button>
        </>
    );
};

export default SelectImage;
